export const type: string = 'xena/search-mask';



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/mapping/searchmask/type.ts